import { contactLink } from "../lib/api";
import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { siteConfig as fallback } from "../mock";
import { HelpCircle, Send } from "lucide-react";
import { useSite } from "../context/SiteContext";

const FAQ = () => {
  const { settings } = useSite();
  const s = settings || fallback;
  const faqs = s.faqs || [];
  return (
    <section id="faq" className="bg-navy-800 py-20 md:py-28">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="reveal text-center mb-14">
          <p className="text-gold text-sm font-semibold tracking-widest uppercase mb-3">Got Questions?</p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white">Frequently Asked Questions</h2>
        </div>
        <div className="reveal">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="bg-navy-700 border border-white/10 rounded-2xl px-6 data-[state=open]:border-gold/40 transition-colors">
                <AccordionTrigger className="text-white hover:no-underline hover:text-gold py-5 text-left text-base font-semibold">
                  <span className="flex items-center gap-3"><HelpCircle size={18} className="text-gold shrink-0" />{f.q}</span>
                </AccordionTrigger>
                <AccordionContent className="text-slate-400 leading-relaxed pb-5 pl-9">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
        <div className="reveal mt-10 text-center">
          <p className="text-slate-400 mb-4">Still have a question?</p>
          <a {...contactLink(s.contact?.telegramLink)} className="inline-flex items-center gap-2 bg-gold hover:bg-gold-light text-navy font-semibold px-6 py-3 rounded-xl transition-colors duration-200">
            <Send size={17} /> Chat on Telegram
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
